import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetOrganizationAppsResponseBody } from '../OrganizationsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseOrganizationAppsQueryValues = {
  organizationId: string;
};

export const organizationAppsQueryKeyFactory: IQueryKeyFactory<
  IUseOrganizationAppsQueryValues
> = (values) =>
  values && (['organizationApps', values.organizationId] as const);

export const useOrganizationAppsQuery = (
  values?: IUseOrganizationAppsQueryValues,
  options?: UseQueryOptions<IApiGetOrganizationAppsResponseBody, ApiError>,
): UseQueryResult<IApiGetOrganizationAppsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: organizationAppsQueryKeyFactory(values),
    queryFn: values
      ? () => api.organizations.getApps(values.organizationId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
